import React from 'react'
import {Container} from 'react-bootstrap'

const HomePage = props => {
  return (
    <Container className="my-2">
      <h2>Home page</h2>
    </Container>
  )
}

export default HomePage
